<template>
    <div v-if="announcementInfo != null">
        <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="handleChangeTab" :before-leave="beforeLeave">
            <el-tab-pane :label="$t('message.item_bell_info')" name="announcementInfo"></el-tab-pane>
            <!--  Add the tab of targetGroup when multi target groups is supported -->

            <template v-if="selectedTabName==='announcementInfo'">
                <div class="object-titlebox">
                    <div class="object-titlebox-right">
                        <button class="transparent-button" type="button" v-on:click="showDialog('delete')"><img src="../../assets/delete.svg"/><span class="important-command-text" v-t="'message.common_action_delete'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('qr')"><img src="../../assets/qr.svg"/><span class="normal-command-text" v-t="'message.action_show_qr'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('duplicate')"><img src="../../assets/copy.svg"/><span class="normal-command-text" v-t="'message.action_duplicate'"></span></button>
                        <button class="transparent-button" type="button" v-on:click="showDialog('edit')"><img src="../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                    </div>
                </div>
                <table width=100%>
                    <tr class="objectitem-record"><td class="object-item" width=50% v-t="'message.item_announcement_id'"></td><td class="object-value">{{ announcementInfo.name }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_announcement_connection_channel'"></td><td class="object-value">{{ displayTargetGroupName }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_announcement_continuous_time'"></td><td class="object-value">{{ announcementInfo.continuousMinutes }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_announcement_history_available_time'"></td><td class="object-value">{{ announcementInfo.historyMinutes }}</td></tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_announcement_allow_auto_speak'"></td>
                        <td v-if="announcementInfo.allowAutoSpeak" class="object-value" v-t="'message.item_allowed'"></td>
                        <td v-else class="object-value" v-t="'message.item_not_allowed'"></td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_announcement_set_dark_theme'"></td>
                        <td v-if="announcementInfo.setDarkTheme" class="object-value" v-t="'message.item_set'"></td>
                        <td v-else class="object-value" v-t="'message.item_not_set'"></td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item" v-t="'message.item_announcement_interactive'"></td>
                        <td v-if="announcementInfo.interactive" class="object-value" v-t="'message.value_on'"></td>
                        <td v-else class="object-value" v-t="'message.value_off'"></td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item">
                            <div v-t="'message.item_announcement_usage_time'"/>
                            <div style="font-size:10px; font-weight:bold; color:#67b853" v-html="$t('message.info_bell_usage_time_hint')"></div>
                        </td>
                        <td v-if="enableUsageTime" class="object-value">
                            <div>
                                {{ displayUsageTime }}
                            </div>
                        </td>
                        <td v-else class="object-value">
                            <span v-t="'message.item_value_notSet'"/>
                        </td>
                    </tr>
                    <tr class="objectitem-record">
                        <td class="object-item">
                            <div v-t="'message.item_announcement_usage_point'"/>
                            <div style="font-size:10px; font-weight:bold; color:#67b853" v-html="$t('message.info_bell_usage_point_hint')"></div>
                        </td>
                        <td v-if="enabledUsagePoint" class="object-value">
                            <span v-t="'message.item_value_inSet'"/>
                            <div>
                                <button class="transparent-button" type="button" @click="showUsagePointAnnouncement()">
                                    <i class="el-icon-location-information"/>
                                    <span class="normal-command-text" style="margin-left:5px" v-t="'message.item_bell_check_usage_point'"/>
                                </button>
                            </div>
                        </td>
                        <td v-else class="object-value">
                            <span v-t="'message.item_value_notSet'"/>
                        </td>
                    </tr>
                    <!-- ベルを常時表示する -->
<!--                    <tr class="objectitem-record">-->
<!--                        <td class="object-item">-->
<!--                            <div v-t="'message.item_bell_valid_display_time'"/>-->
<!--                            <div style="font-size:10px; font-weight:bold; color:#67b853" v-html="$t('message.info_bell_always_display_hint')"></div>-->
<!--                        </td>-->
<!--                        <td v-if="announcementInfo.enableAlwaysDisplay" class="object-value">-->
<!--                            <span v-t="'message.value_on'"/>-->
<!--                        </td>-->
<!--                        <td v-else class="object-value">-->
<!--                            <span v-t="'message.value_off'"/>-->
<!--                        </td>-->
<!--                    </tr>-->
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_announcement_created_time'"></td><td class="object-value">{{ displayCreatedTime }}</td></tr>
                    <tr class="objectitem-record"><td class="object-item" v-t="'message.item_announcement_updated_time'"></td><td class="object-value">{{ displayUpdatedTime }}</td></tr>
                </table>

<!--                <div class="object-titlebox">-->
<!--                    <div class="object-titlebox-left">-->
<!--                        <span>{{ $t('message.item_bell_display_setting') }}</span>-->
<!--                    </div>-->
<!--                    <div class="object-titlebox-right">-->
<!--                        <button class="transparent-button" type="button" v-on:click="showDialog('editSettings')"><img src="../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div v-if="existsSettings">-->
<!--                    <table width=100%>-->
<!--                        <tr class="objectitem-record"><td class="object-item" width=50% v-t="'message.item_bell_display_languages'"></td><td class="object-value">{{ displayLanguages }}</td></tr>-->
<!--                        <tr class="objectitem-record"><td class="object-item" v-t="'message.item_bell_display_page_contents'"></td>-->
<!--                            <td class="object-value">-->
<!--                                <div>-->
<!--                                    <button class="transparent-button" type="button" @click="previewAnnouncement()"><i class="el-icon-full-screen"></i><span class="normal-command-text" style="margin-left:5px" v-t="'message.action_preview'"></span></button>-->
<!--                                </div>-->
<!--                            </td>-->
<!--                        </tr>-->
<!--                    </table>-->
<!--                </div>-->
<!--                <div v-else class="default-message" style="margin-top: 30px" v-html="$t('message.info_message_unset')"/>-->
            </template>

<!--            <template v-else-if="selectedTabName==='authUser'">-->
<!--                <div class="default-message" style="padding: 30px">-->
<!--                    <br>-->
<!--                    <span v-html="$t('message.info_bell_auth_guide1')"></span>-->
<!--                    <br><br>-->
<!--                    <span>-->
<!--                        <a :href="announcementDashboardUrl" target="_blank">{{ announcementDashboardUrl }}</a>-->
<!--                    </span>-->
<!--                    <br><br>-->
<!--                </div>-->
<!--                <div class="object-titlebox">-->
<!--                    <div class="object-titlebox-left" v-t="{ path: 'message.title_bell_auth_user', args: { name: announcementInfo.name, userCount: authUserList.length} }"></div>-->
<!--                    <div class="object-titlebox-right">-->
<!--                        <div v-if="authUserList.length === 0">-->
<!--                            <button class="transparent-button" type="button" v-on:click="showDialog('editAuth')"><img src="../../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.action_add_user'"></span></button>-->
<!--                        </div>-->
<!--                        <div v-else>-->
<!--                            <button class="transparent-button" type="button" v-on:click="showDialog('editAuth')"><img src="../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.action_edit_user'"></span></button>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <table width=100%>-->
<!--                    <tr class="authorized-user-title">-->
<!--                        <td class="authorized-user-header1" v-t="'message.item_userId_displayName'"></td>-->
<!--                        <td class="authorized-user-header2" v-t="'message.common_action_delete'"></td>-->
<!--                    </tr>-->
<!--                    <tr class="authorized-user-record" v-for="(user, _) in authUserList">-->
<!--                        <td class="object-item">{{ authUserDescription(user) }}</td>-->
<!--                        <td class="object-item2">-->
<!--                            <button class="item-record-button" type="button" v-on:click="confirmDeleteAnnouncementAuth(user)"><img class="icon-delete" src="../assets/icon_delete_user.svg"/></button>-->
<!--                        </td>-->
<!--                    </tr>-->
<!--                </table>-->
<!--                <div v-if="authUserList.length === 0" class="default-message" style="margin-top: 30px" v-html="$t('message.info_message_unset')"/>-->
<!--            </template>-->

        </el-tabs>

        <!-- announcementInfo tab -->
        <QrAnnouncement v-if="showQrAnnouncement" :announcementInfo="{tenantId: tenantId, id: announcementInfo.id, name: announcementInfo.name}" :announcementClientUrl="announcementClientUrl" @back="showQrAnnouncement=false"></QrAnnouncement>
        <EditAnnouncement v-if="showEditAnnouncement" :appData="appData" :announcementInfo="announcementInfo" @update="updateAnnouncement" @cancel="showEditAnnouncement=false"></EditAnnouncement>
<!--        <EditAnnouncementSettings v-if="showEditAnnouncementSettings" :appData="appData" :announcementInfo="announcementInfo" @update="updateAnnouncement" @cancel="showEditAnnouncementSettings=false"></EditAnnouncementSettings>-->
        <DeleteAnnouncement v-if="showDeleteAnnouncement" :confirmInfo="confirmInfo" @delete="deleteAnnouncement" @cancel="showDeleteAnnouncement=false"></DeleteAnnouncement>
        <DuplicateAnnouncement v-if="showDuplicateAnnouncement" :appData="appData" :announcementInfo="announcementInfo" @save="duplicateAnnouncement" @cancel="showDuplicateAnnouncement=false"></DuplicateAnnouncement>
        <!-- authUser tab -->
<!--        <EditAnnouncementAuth v-if="showEditAnnouncementAuth" :appData="appData" :authUsers="authUserListForUserSelection()" @update="editAnnouncementAuth" @cancel="showEditAnnouncementAuth=false"></EditAnnouncementAuth>-->
<!--        <DeleteAnnouncementAuth v-if="showDeleteAnnouncementAuth" :confirmInfo="userConfirmInfo" @delete="deleteAnnouncementAuth" @cancel="showDeleteAnnouncementAuth=false"></DeleteAnnouncementAuth>-->
    </div>
</template>

<script>
import server from "../ServerApi.js";
import QrAnnouncement from "./AnnouncementQr.vue";
import EditAnnouncement from "./AnnouncementEdit.vue";
// import EditAnnouncementSettings from "./AnnouncementEditDisplaySettings.vue"
import DeleteAnnouncement from "./AnnouncementDelete.vue";
import DuplicateAnnouncement from "./AnnouncementDuplicate.vue";
// import EditAnnouncementAuth from "./AnnouncementAuthEdit.vue";
// import DeleteAnnouncementAuth from "./AnnouncementAuthDelete.vue";
import commonUtil from '../commonutil.js';
import constants from '../constants.js';

export default {
    components: {
        QrAnnouncement,
        EditAnnouncement,
        // EditAnnouncementSettings,
        DeleteAnnouncement,
        DuplicateAnnouncement,
        // EditAnnouncementAuth,
        // DeleteAnnouncementAuth,
    },

    props: {
        selectedNode: Object,
        appData: Object,
        announcementDashboardUrl: String,
        announcementClientUrl: String,
    },

    data() {
        return {
            tenantId: null,
            announcementInfo: null,
            showTab: true,
            selectedTabName: null,
            loadingScreen: null,
            isAdminUser: false,

            // announcementInfo tab
            // languageList: [],
            // notificationItems: [],
            showQrAnnouncement: false,
            showEditAnnouncement: false,
            showEditAnnouncementSettings: false,
            showDeleteAnnouncement: false,
            showDuplicateAnnouncement: false,
            showPreviewAnnouncement: false,
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },

            // authUser tab
            // authUserList: [],
            // showEditAnnouncementAuth: false,
            // showDeleteAnnouncementAuth: false,
            // userConfirmInfo: {
            //     user: null,
            // },
        };
    },

    computed: {
        existsSettings() {
            return this.announcementInfo != null
        },
        // displayLanguages() {
        //     if (!this.existsSettings) {
        //         return "";
        //     }
        //     return this.languageList
        //         .filter(lang => this.announcementInfo.settings.context[lang.languageCode])
        //         .map(lang => this.languageDescription(lang))
        //         .join(' / ')
        // },
        displayTargetGroupName() {
            return this.announcementInfo.group.talkgroupName;
        },
        // displayNotifyLang() {
        //     let language = this.languageList.find(lang => lang.value === this.announcementInfo.notifyLang)
        //     return this.languageDescription(language);
        // },
        // displayNotifyItems() {
        //     return this.notificationItems
        //         .filter(item => this.announcementInfo.notifyItems.includes(item.name))
        //         .map(item => this.notificationItemDescription(item))
        //         .join(' / ')
        // },
        displayUsageTime() {
            if (this.enableUsageTime) {
                // Human-friendly notation
                let localStart, localEnd;
                let offset = -(new Date().getTimezoneOffset());
                localStart = this.calculateMinutes(this.announcementInfo.usageTime.start, offset);
                localEnd   = this.calculateMinutes(this.announcementInfo.usageTime.end, offset);
                if (localStart === '24:00') {
                    localStart = '00:00';
                }
                if (localEnd === '00:00') {
                    localEnd = '24:00';
                }
                return `${localStart} - ${localEnd}`;
            } else {
                return commonUtil.getMessageText(this.$i18n, "item_value_notSet")
            }
        },
        displayCreatedTime() {
            return new Date(this.announcementInfo.createdTime).toLocaleString();
        },
        displayUpdatedTime() {
            return new Date(this.announcementInfo.updatedTime).toLocaleString();
        },
        enableUsageTime() {
            return this.announcementInfo.usageTime.start && this.announcementInfo.usageTime.end && (this.announcementInfo.usageTime.start !== this.announcementInfo.usageTime.end);
        },
        enabledUsagePoint() {
            return this.announcementInfo.usagePoint.latitude && this.announcementInfo.usagePoint.longitude;
        }
    },

    watch: {
        selectedNode: {
            handler(newVal, oldVal) {
                this.getAnnouncementDetail();
            }
        },
        'appData.onlinePurchase'(newVal) {
            this.getAnnouncementDetail();
        }
    },

    created() {
        this.tenantId = this.appData.tenantList[0].tenantId;
        this.languageList = commonUtil.getLanguageIndexList(this.$i18n.locale)
        // this.notificationItems = commonUtil.getAnnouncementNotificationItems();
        this.selectedTabName = "announcementInfo";
        this.getAnnouncementDetail();
    },

    methods: {
        languageDescription(language) {
            if (this.$i18n.locale === 'ja') {
                return language.description;
            } else {
                return language.description_en
            }
        },
        notificationItemDescription(item) {
            if (this.$i18n.locale === 'ja') {
                return item.description;
            } else {
                return item.description_en
            }
        },
        authUserDescription(user) {
            return user.userName + "@" +  this.appData.tenantList[0].name + " / " + user.displayName;
        },
        authUserListForUserSelection() {
            return this.authUserList.map(user => {
                return {
                    tenantId: this.tenantId,
                    id: user.userId,
                    pid: 0,
                    name: user.userName,
                    displayName: user.displayName,
                    restrictions: user.restrictions,
                    rights: user.rights,
                    publishInformations: user.publishInformations,
                    optionFlag: user.optionFlag,
                }
            });
        },
        calculateMinutes(time, minutes) {
            const parts = time.split(':');
            const date = new Date();
            date.setHours(parts[0]);
            date.setMinutes(parts[1]);

            date.setMinutes(date.getMinutes() + minutes);

            const hours = date.getHours().toString().padStart(2, '0');
            const mins = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${mins}`;
        },
        async getAnnouncementDetail() {
            if (this.selectedNode == null) {
                return;
            }

            this.showLoadingScreen();
            try {
                const res = await server.post('/getannouncement', {id: this.selectedNode.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        console.log(res.data.status)
                        this.announcementInfo = res.data.data;
                        // this.getAnnouncementAuthUsers();
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_not_found"));
                        this.$emit('refresh', true);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getAnnouncementDetail").replace("{code}", res.data.status));
                        break;
                }
                this.closeLoadingScreen();

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getAnnouncementDetail", e);
                this.closeLoadingScreen();
            }
        },
        // async getAnnouncementAuthUsers() {
        //     try {
        //         const res = await server.post('/getannouncementauthuser', {id: this.bellInfo.id})
        //         switch (res.data.status) {
        //             case constants.STATUS_SUCCESS:
        //                 res.data.users.sort((u1, u2) => {
        //                     return commonUtil.compareStringWithNumber(u1.userName, u2.userName);
        //                 });
        //                 this.authUserList = res.data.users;
        //                 break;
        //             default:
        //                 commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getAnnouncementAuthUsers").replace("{code}", res.data.status));
        //                 break;
        //         }
        //
        //     } catch (e) {
        //         commonUtil.putExceptionErrorMessage(this, "getAnnouncementAuthUsers", e);
        //     }
        // },
        async updateAnnouncement(payload) {
            try {
                const res = await server.post("/updateannouncement", payload);
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_edit_success"));
                        this.showEditAnnouncement = false;
                        this.showEditAnnouncementSettings = false;
                        if (payload.name) {
                            // In case of invoked from AnnouncementEdit, not AnnouncementDisplaySettings
                            this.selectedNode.name = payload.name
                        }
                        this.getAnnouncementDetail();
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_error_exists_same_name"));
                        break;
                    case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_count"));
                        break;
                    case constants.STATUS_ERROR_EXCEEDS_MAX_SIZE:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_size"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "updateAnnouncement").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "getInfo", e);
            }
        },
        async deleteAnnouncement() {
            try {
                const res = await server.post("/deleteannouncement", {id: this.announcementInfo.id})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "item_bell_delete_success"));
                        this.showDeleteAnnouncement = false;
                        this.$emit('refresh', true);
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deleteAnnouncement").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "deleteAnnouncement", e);
            }
        },
        async duplicateAnnouncement(originalAnnouncementInfo, newAnnouncementName) {
            try {
                const res = await server.post("/duplicateannouncement", {originalId: originalAnnouncementInfo.id, name: newAnnouncementName})
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "item_bell_duplicated_success"));
                        this.showDuplicateAnnouncement = false;
                        this.$emit('refresh');
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_error_exists_same_name"));
                        break;
                    case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_max_count"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "duplicateAnnouncement").replace("{code}", res.data.status));
                        break;
                }

            } catch (e) {
                commonUtil.putExceptionErrorMessage(this, "duplicateAnnouncement", e);
            }
        },
        // async deleteAnnouncementAuth() {
        //     this.showDeleteAnnouncementAuth = false;
        //
        //     try {
        //         const res = await server.post("/editannouncementauthuser", {id: this.bellInfo.id, addUserIdList: [], deleteUserIdList: [this.userConfirmInfo.user.userId]})
        //         switch (res.data.status) {
        //             case constants.STATUS_SUCCESS:
        //                 commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_auth_deleted"));
        //                 this.getAnnouncementAuthUsers();
        //                 break;
        //             default:
        //                 commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "deleteAnnouncementAuth").replace("{code}", res.data.status));
        //                 break;
        //         }
        //     } catch (e) {
        //         commonUtil.putExceptionErrorMessage(this, "editAnnouncementAuth", e);
        //     }
        // },
        // async editAnnouncementAuth(removeTagList, addTagList) {
        //     this.showEditAnnouncementAuth = false;
        //
        //     let addUserIdList = [];
        //     let deleteUserIdList = [];
        //
        //     if (addTagList) {
        //         for (let key in addTagList) {
        //             addUserIdList.push(addTagList[key].userId);
        //         }
        //     }
        //
        //     if (removeTagList) {
        //         for (let key in removeTagList) {
        //             deleteUserIdList.push(removeTagList[key].userId);
        //         }
        //     }
        //
        //     if (addUserIdList.length === 0 && deleteUserIdList.length === 0) {
        //         commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_no_changing_information"));
        //         return;
        //     }
        //
        //     if (this.authUserList.length + addUserIdList.length - deleteUserIdList.length > constants.BELL_MAX_AUTH_USER_LIMIT) {
        //         commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_bell_max_auth_user_count").replace("{limit}", constants.BELL_MAX_AUTH_USER_LIMIT));
        //         return;
        //     }
        //
        //     try {
        //         const res = await server.post("/editannouncementauthuser", {id: this.bellInfo.id, addUserIdList: addUserIdList, deleteUserIdList: deleteUserIdList})
        //         switch (res.data.status) {
        //             case constants.STATUS_SUCCESS:
        //                 commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_bell_auth_edited"));
        //                 this.getAnnouncementAuthUsers();
        //                 break;
        //             case constants.STATUS_ERROR_BELL_AUTH_USER_LIMIT:
        //                 commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_bell_exceed_auth_max_count")
        //                     .replace("{user_limit}", constants.BELL_MAX_AUTH_USER_LIMIT)
        //                     .replace("{bell_limit}", constants.BELL_MAX_AUTHED_BELL_LIMIT));
        //                 break;
        //             default:
        //                 commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "editAnnouncementAuth").replace("{code}", res.data.status));
        //                 break;
        //         }
        //     } catch (e) {
        //         commonUtil.putExceptionErrorMessage(this, "editAnnouncementAuth", e);
        //     }
        // },
        previewAnnouncement() {
            let url = `${this.announcementClientUrl}?preview=true`;

            let width = 400;
            let height = 700;
            let left = (window.screen.width / 2) - (width / 2);
            let top = (window.screen.height / 2) - (height / 2);

            const popup = window.open(url, '_blank', `width=${width},height=${height},left=${left},top=${top}`);
            if (popup !== null) {
                // a little wait pre postMessage
                setTimeout(() => popup.postMessage(
                    {displayName: this.announcementInfo.displayName, settings: this.announcementInfo.settings},
                    this.announcementClientUrl
                ), 500);
            }
        },
        showUsagePointAnnouncement() {
            let latitude = this.announcementInfo.usagePoint.latitude;
            let longitude = this.announcementInfo.usagePoint.longitude;
            let url = `https://www.google.com/maps?q=${latitude},${longitude}`
            // &hl=${your_language}&region=${your_region}&z=15`;
            window.open(url, '_blank',"noopener,noreferrer");
        },
        confirmDeleteAnnouncementAuth(user) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }
            this.userConfirmInfo.user = user;
            this.showDeleteAnnouncementAuth = true;
        },
        showDialog(functionName) {
            if (this.appData.csvProcessing) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_import_processing"));
                return;
            }

            switch (functionName) {
                case "edit":
                    this.showEditAnnouncement = true;
                    break;
                case "editSettings":
                    this.showEditAnnouncementSettings = true;
                    break;
                case "duplicate":
                    this.showDuplicateAnnouncement = true;
                    break;
                case "delete":
                    this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n, "item_bell");
                    this.confirmInfo.objectName = this.announcementInfo.name;
                    this.showDeleteAnnouncement = true;
                    break;
                case "qr":
                    if (!this.existsSettings) {
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_bell_qr_need_display_settings"));
                        break;
                    }
                    this.showQrAnnouncement = true;
                    break;
                case "editAuth":
                    this.showEditAnnouncementAuth = true;
                    break;
                default:
                    break;
            }
        },
        // handleChangeTab() {
        //     if (this.selectedTabName === "authUser") {
        //         this.getAnnouncementAuthUsers();
        //     }
        //     this.reDrawTab();
        // },
        beforeLeave(activeName, oldActiveName) {
            return true;
        },
        showLoadingScreen() {
            if (this.loadingScreen == null) {
                this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
                });
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                this.showTab = true
            })
        },
    }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
    list-style:none;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
}
.modal-default-button {
    float: right;
}

input[type="radio"]{
    outline: 0;
    -webkit-appearance: none;
    position: relative;
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url(../../assets/icon_check_gray.svg);
}
input[type="radio"]:checked {
    outline: 0;
    width: 20px;
    height: 20px;
    background: url(../../assets/icon_check_green.svg);
}
input[type="radio"]:hover {
    cursor : pointer;
}
.authorized-user-record {
    border-bottom:1px #eee solid;
}
.authorized-user-record:hover {
    background-color: #ecf1fa;
}
.authorized-user-title {
    width: 100%;
    padding: 10px 0 10px 28px;
    display: table-row;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
    background-color: #f6f6f6;
}
.authorized-user-header1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.authorized-user-header2 {
    width: 15%;
    text-align:center;
}
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.custom-checkbox-input {
    display: none;
}

.action-icon {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}
</style>
